import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
// @mui
import {
  Stack,
  Button,
  Typography,
  TextField
} from '@mui/material';

// components
import Iconify from '../iconify';
import DocumentNumberField from '../document-number-field'
import { maskPhone } from '../../utils/phoneMask'

SignerCard.propTypes = {
  signerPhone: PropTypes.string,
  setSignerPhone: PropTypes.func,
  signerPhoneError: PropTypes.string,
};

export default function SignerCard(props) {

    return (
        <Stack justifyContent="space-between" mb={5}>
            <Typography sx={{ m: 2 }} >Informaçõe do assinante</Typography>
                <Stack direction="row" alignItems="center" justifyContent="center">
                    <TextField sx={{ m: 2 }}
                    label="Nome do Assinante" 
                    variant="outlined"
                    value={props.signerName}
                    onChange={e => props.setSignerName(e.target.value)}/>
                    <DocumentNumberField 
                    documentNumber={props.signerDocumentNumber} 
                    setDocumentNumber={props.setSignerDocumentNumber} 
                    documentNumberError={props.signerDocumentNumberError}
                    setDocumentNumberError={props.setSignerDocumentNumberError}
                    />
                    <TextField sx={{ m: 2 }}
                    label="Email do assinante" 
                    variant="outlined"
                    value={props.signerEmail}
                    onChange={e => props.setSignerEmail(e.target.value)}/>
                    {props.setSignerPhone && (
                    <TextField sx={{ m: 2 }}
                    label="Celular do assinante"
                    variant="outlined"
                    type="tel"
                    placeholder="(11) 98765-4321"
                    value={props.signerPhone}
                    error={Boolean(props.signerPhoneError)}
                    helperText={props.signerPhoneError}
                    onChange={e => props.setSignerPhone(maskPhone(e.target.value))}/>
                    )}
                    </Stack>
                    <Stack direction="row" alignItems="left" justifyContent="flex-end">
                    <Button 
                    sx={{ m: 2 }} 
                    variant="contained" 
                    component="label" 
                    startIcon={<Iconify icon="eva:plus-fill" />}
                    onClick={_ => props.handleCreateSigner()}>
                    Adicionar assinante
                    </Button>
                </Stack>
            </Stack>
    );
}
